import { render, staticRenderFns } from "./TableSortable.vue?vue&type=template&id=cbb560a4&scoped=true&"
import script from "./TableSortable.vue?vue&type=script&lang=js&"
export * from "./TableSortable.vue?vue&type=script&lang=js&"
import style0 from "./TableSortable.vue?vue&type=style&index=0&id=cbb560a4&scoped=true&lang=scss&"
import style1 from "./TableSortable.vue?vue&type=style&index=1&id=cbb560a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb560a4",
  null
  
)

component.options.__file = "TableSortable.vue"
export default component.exports